import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    current_pid: -1,
    userName: null,
    is_master: false,
    newGeom: null,
    newFeatureType: null,
    searchResultFeatureIDs: {
      point_gids: [],
      line_gids: [],
      polygon_gids: [],
    },
    isFullScreen: false,
    showLegendPanel: false,
    legend: [
      {
        type: "古村古道",
        color: { stroke: "#ccc", fill: "#da8c42bf" },
        selected: false,
      },
      {
        type: "红色历史",
        color: { stroke: "#ccc", fill: "#ff0000bf" },
        selected: false,
      },
      {
        type: "民间民俗",
        color: { stroke: "#ccc", fill: "#ff55ffbf" },
        selected: false,
      },
      {
        type: "生态山水",
        color: { stroke: "#ccc", fill: "#02f7e7bf" },
        selected: false,
      },
      {
        type: "宗教寺庙",
        color: { stroke: "#ccc", fill: "#fceb21bf" },
        selected: false,
      },
      {
        type: "京西煤业",
        color: { stroke: "#ccc", fill: "#393939bf" },
        selected: false,
      }, 
    ], 
    
    searchResultDialogType: 1,//1 地图弹框  2查询弹框
    showAddLocalVectorData:false
  },
  getters: {},
  mutations: {
    setShowAddLocalVectorData(state, data) {
      state.showAddLocalVectorData = data;
    },
    setSearchResultDialogType(state, data) {
      state.searchResultDialogType = data;
    },
    setSearchResultFeatureIDs(state, data) {
      state.searchResultFeatureIDs = data;
    },
    toggleShowLegendPanel(state) {
      state.showLegendPanel = !state.showLegendPanel;
    },
    toggleFullScreen(state) {
      state.isFullScreen = !state.isFullScreen;
    },
    setCurrentPid: (state, data) => {
      state.current_pid = data;
    },
    setUserName: (state, data) => {
      state.userName = data;
    },
    setNewGeom: (state, data) => {
      state.newGeom = data;
    },
    setNewFeatureType: (state, data) => {
      state.newFeatureType = data;
    },
    setSearchResult: (state, data) => {
      state.searchResult = data;
    },
    updateSearchResult(state, data) {
      let index = -1;
      state.searchResult.featureList.forEach((element, i) => {
        if (data.gid == element.gid) {
          index = i
        }
      });
      if (index > -1) {
        state.searchResult.featureList.splice(index, 1)
      }

    }
  },
  modules: {}
});